/* ==========================================================================
   Louis Vuitton Date Code Checker — Vintasje
   Toegevoegd door Elivado, 2026-08-24. Zelfde opzet als de Chanel checker.

   Volledig client-side: geen backend, geen dependencies. De tool werkt per
   instantie (data-lv-checker), dus de sectie mag meerdere keren op een
   pagina staan en her-initialiseert zichzelf in de theme editor.
   ========================================================================== */

(function () {
  'use strict';

  /* ------------------------------------------------------------------------
     Louis Vuitton gebruikte tot maart 2021 een date code. De opbouw is in de
     loop der jaren drie keer veranderd:

       begin jaren 80   3-4 cijfers, geen letters      -> 831  = jan 1983
       eind jaren 80    3-4 cijfers + 2 letters        -> 874TH = apr 1987
       1990 t/m 2006    2-3 letters + 4 cijfers        -> cijfer 1+3 = maand,
                                                          cijfer 2+4 = jaar
       2007 t/m 3/2021  2-3 letters + 4 cijfers        -> cijfer 1+3 = week,
                                                          cijfer 2+4 = jaar

     Vanaf maart 2021 zit er geen date code meer in; die is vervangen door een
     ingebouwde microchip. Louis Vuitton heeft nooit een officiele tabel
     gepubliceerd — behandel dit als een schatting, niet als een feit.
     ------------------------------------------------------------------------ */

  var MONTHS = [
    'January', 'February', 'March', 'April', 'May', 'June',
    'July', 'August', 'September', 'October', 'November', 'December'
  ];

  /* Ateliercodes per land. Sommige codes zijn in meerdere landen gebruikt;
     die staan daarom bewust bij elk land waar ze voorkomen. */
  var FACTORY_GROUPS = [
    ['France', ['A0', 'A1', 'A2', 'AA', 'AAS', 'AH', 'AN', 'AR', 'AS', 'BA', 'BJ', 'BU',
      'CO', 'CT', 'DR', 'DT', 'DU', 'ET', 'FL', 'LA', 'LM', 'LW', 'MB', 'MI', 'NO', 'RA',
      'RI', 'SA', 'SD', 'SF', 'SL', 'SN', 'SP', 'SR', 'TA', 'TH', 'TJ', 'TN', 'TR', 'TS',
      'VI', 'VX']],
    ['Spain', ['BC', 'BO', 'CA', 'CR', 'GI', 'LB', 'LM', 'LO', 'LW', 'UB']],
    ['Italy', ['BC', 'BO', 'CE', 'FN', 'FO', 'MA', 'NZ', 'OB', 'PL', 'RC', 'RE', 'SA', 'TD']],
    ['Germany', ['LP', 'OL']],
    ['the United States', ['FA', 'FC', 'FH', 'FL', 'LA', 'OS', 'SD', 'TX']],
    ['Switzerland', ['DI', 'FA']]
  ];

  var FACTORIES = {};
  FACTORY_GROUPS.forEach(function (group) {
    group[1].forEach(function (code) {
      if (!FACTORIES[code]) FACTORIES[code] = [];
      if (FACTORIES[code].indexOf(group[0]) === -1) FACTORIES[code].push(group[0]);
    });
  });

  function clean(raw) {
    return raw.toUpperCase().replace(/[\s\-\.]/g, '');
  }

  /* "France" / "France or Italy" / "France, Italy or Spain" */
  function joinList(items) {
    if (items.length === 1) return items[0];
    return items.slice(0, -1).join(', ') + ' or ' + items[items.length - 1];
  }

  function factorySentence(prefix) {
    var countries = FACTORIES[prefix];
    if (!countries) {
      return ' The letters <strong>' + prefix + '</strong> are not in our workshop list — ' +
        'double-check them against the code in your bag.';
    }
    return ' The letters <strong>' + prefix + '</strong> point to a workshop in ' +
      joinList(countries) + '.';
  }

  function init(root) {
    if (!root || root.dataset.lvReady === 'true') return;
    root.dataset.lvReady = 'true';

    var input = root.querySelector('[data-lv-input]');
    var button = root.querySelector('[data-lv-button]');
    var result = root.querySelector('[data-lv-result]');
    var label = root.querySelector('[data-lv-result-label]');
    var value = root.querySelector('[data-lv-result-value]');
    var text = root.querySelector('[data-lv-result-text]');

    if (!input || !button || !result || !label || !value || !text) return;

    function showResult(state, labelText, valueText, textHtml) {
      result.classList.add('is-visible');
      result.classList.toggle('is-error', state === 'error');
      label.textContent = labelText;
      value.textContent = valueText;
      text.innerHTML = textHtml;
    }

    function checkCode() {
      var code = clean(input.value);

      if (!code) {
        showResult(
          'error',
          'Enter a code',
          'No code entered',
          'Type the date code from your Louis Vuitton item into the field above and press Check.'
        );
        return;
      }

      /* --- 1990 t/m maart 2021: 2-3 letters + 4 cijfers -------------------- */
      var modern = code.match(/^([A-Z][A-Z0-9]{1,2})([0-9]{4})$/);
      if (modern) {
        var prefix = modern[1];
        var digits = modern[2];
        var yy = parseInt(digits.charAt(1) + digits.charAt(3), 10);
        var nn = parseInt(digits.charAt(0) + digits.charAt(2), 10);

        /* jaar 90-99 -> jaren 90, 00-06 -> maandnotatie, 07-21 -> weeknotatie */
        if (yy >= 90) {
          if (nn >= 1 && nn <= 12) {
            showResult(
              'ok',
              'Estimated production date',
              MONTHS[nn - 1] + ' ' + (1900 + yy),
              'Date code <strong>' + code + '</strong> reads as month ' + nn + ', year ' +
                (1900 + yy) + '.' + factorySentence(prefix)
            );
          } else {
            showResult(
              'unknown',
              'Format recognised, date unclear',
              'Month ' + nn + ' does not exist',
              'Between 1990 and 2006 the 1st and 3rd digits are the month, so we read month ' +
                nn + ' here — which is not a real month. Double-check the digits.' +
                factorySentence(prefix)
            );
          }
          return;
        }

        if (yy <= 6) {
          if (nn >= 1 && nn <= 12) {
            showResult(
              'ok',
              'Estimated production date',
              MONTHS[nn - 1] + ' ' + (2000 + yy),
              'Date code <strong>' + code + '</strong> reads as month ' + nn + ', year ' +
                (2000 + yy) + '.' + factorySentence(prefix)
            );
          } else {
            showResult(
              'unknown',
              'Format recognised, date unclear',
              'Month ' + nn + ' does not exist',
              'Up to 2006 the 1st and 3rd digits are the month, so we read month ' + nn +
                ' here — which is not a real month. Double-check the digits.' +
                factorySentence(prefix)
            );
          }
          return;
        }

        if (yy <= 21) {
          if (nn >= 1 && nn <= 53) {
            showResult(
              'ok',
              'Estimated production date',
              'Week ' + nn + ', ' + (2000 + yy),
              'From 2007 onwards the 1st and 3rd digits are the week number, so date code ' +
                '<strong>' + code + '</strong> reads as week ' + nn + ' of ' + (2000 + yy) + '.' +
                factorySentence(prefix)
            );
          } else {
            showResult(
              'unknown',
              'Format recognised, date unclear',
              'Week ' + nn + ' does not exist',
              'From 2007 onwards the 1st and 3rd digits are the week number, so we read week ' +
                nn + ' here — a year only has 52 or 53 weeks. Double-check the digits.' +
                factorySentence(prefix)
            );
          }
          return;
        }

        showResult(
          'unknown',
          'Format recognised, year unclear',
          'Year ' + digits.charAt(1) + digits.charAt(3),
          'The 2nd and 4th digits should give the year, but ' + digits.charAt(1) +
            digits.charAt(3) + ' does not match a period in which Louis Vuitton used date ' +
            'codes (roughly 1980 to March 2021).' + factorySentence(prefix)
        );
        return;
      }

      /* --- eind jaren 80: 3-4 cijfers + 2 letters -------------------------- */
      var eighties = code.match(/^([0-9]{3,4})([A-Z]{2})$/);
      if (eighties) {
        var digits80 = eighties[1];
        var prefix80 = eighties[2];
        var year80 = parseInt(digits80.substring(0, 2), 10);
        var month80 = parseInt(digits80.substring(2), 10);
        if (month80 >= 1 && month80 <= 12) {
          showResult(
            'ok',
            'Estimated production date',
            MONTHS[month80 - 1] + ' ' + (1900 + year80),
            'This is the late-1980s format: the first two digits are the year and the rest ' +
              'is the month.' + factorySentence(prefix80)
          );
        } else {
          showResult(
            'unknown',
            'Format recognised, date unclear',
            'Month ' + month80 + ' does not exist',
            'This looks like the late-1980s format, but ' + month80 + ' is not a real month. ' +
              'Double-check the digits.' + factorySentence(prefix80)
          );
        }
        return;
      }

      /* --- begin jaren 80: alleen 3-4 cijfers ------------------------------ */
      var early = code.match(/^([0-9]{3,4})$/);
      if (early) {
        var year3 = parseInt(early[1].substring(0, 2), 10);
        var month3 = parseInt(early[1].substring(2), 10);
        if (year3 >= 80 && year3 <= 89 && month3 >= 1 && month3 <= 12) {
          showResult(
            'ok',
            'Estimated production date',
            MONTHS[month3 - 1] + ' ' + (1900 + year3),
            'This is the earliest date code format, used in the 1980s: the first two ' +
              'digits are the year and the rest is the month. These codes carry no workshop letters.'
          );
        } else {
          showResult(
            'unknown',
            'Digits only, date unclear',
            'Cannot place this code',
            'Codes without letters were only used in the 1980s, where the first two ' +
              'digits are the year (80–89). Double-check the code, or check whether there are ' +
              'letters after the digits.'
          );
        }
        return;
      }

      /* --- alleen letters: waarschijnlijk halve code ----------------------- */
      if (/^[A-Z]{2,3}$/.test(code)) {
        showResult(
          'error',
          'Incomplete code',
          'Letters only',
          'This looks like just the workshop letters.' + factorySentence(code) +
            ' A full date code has two or three letters followed by four digits, for example SD1024.'
        );
        return;
      }

      /* --- alles daarbuiten ------------------------------------------------ */
      showResult(
        'error',
        'Format not recognised',
        'Couldn’t decode this code',
        'This doesn’t match a known Louis Vuitton date code format. Note that Louis Vuitton ' +
          'stopped using date codes in March 2021 and replaced them with an embedded microchip, ' +
          'so newer items have no code at all.'
      );
    }

    button.addEventListener('click', checkCode);
    input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') {
        e.preventDefault();
        checkCode();
      }
    });
  }

  function initAll(scope) {
    var root = scope || document;
    if (root.matches && root.matches('[data-lv-checker]')) init(root);
    Array.prototype.forEach.call(root.querySelectorAll('[data-lv-checker]'), init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  /* Theme editor: sectie opnieuw geladen -> opnieuw koppelen */
  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });
})();
